import styled         from 'styled-components';
import { Typography } from '@mui/material';

export const FormFieldLabel = styled(Typography)`
  height: 100%;
  display: flex;
  font-size: 14px;
  align-items: center;
  line-height: 49px;
`;
